// // authSlice.js

// import { createSlice } from "@reduxjs/toolkit";
// import { apiSlice } from "./apiSlice";
// import {
//   EMAIL_VERIFICATION_URL,
//   VERIFY_EMAIL_URL,
//   PHONE_VERIFICATION_URL,
//   VERIFY_PHONE_URL,
//   COMPLETE_REGISTRATION_URL,
//   LOGIN_URL,
//   LOGOUT_URL,
//   VERIFY_TOKEN_URL,
//   SEND_RESET_LINK_URL,
//   RESET_PASSWORD_URL,
//   CHANGE_PASSWORD_URL,
//   GENERATE_MFA_SECRET_URL,
//   VERIFY_MFA_TOKEN_URL,
//   VERIFY_MFA_TOKEN_LOGIN_URL,
//   CHECK_INCOMPLETE_REGISTRATION_URL, // Add this
// } from "../constants";

// export const authSlice = apiSlice.injectEndpoints({
//   endpoints: (builder) => ({
//     sendEmailCode: builder.mutation({
//       query: (email) => ({
//         url: EMAIL_VERIFICATION_URL,
//         method: "POST",
//         body: email,
//       }),
//     }),
//     verifyEmail: builder.mutation({
//       query: (data) => ({
//         url: VERIFY_EMAIL_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//     sendPhoneCode: builder.mutation({
//       query: (data) => ({
//         url: PHONE_VERIFICATION_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//     verifyPhone: builder.mutation({
//       query: (data) => ({
//         url: VERIFY_PHONE_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//     completeRegistration: builder.mutation({
//       query: (data) => ({
//         url: COMPLETE_REGISTRATION_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//     checkIncompleteRegistration: builder.mutation({
//       query: (email) => ({
//         url: CHECK_INCOMPLETE_REGISTRATION_URL,
//         method: "POST",
//         body: email,
//       }),
//     }),
// login: builder.mutation({
//   query: (data) => ({
//     url: LOGIN_URL,
//     method: "POST",
//     body: data,
//   }),
// }),
// logout: builder.mutation({
//   query: () => ({
//     url: LOGOUT_URL,
//     method: "POST",
//   }),
// }),
// verifyToken: builder.mutation({
//   query: () => ({
//     url: VERIFY_TOKEN_URL,
//     method: "POST",
//   }),
// }),
// sendResetLink: builder.mutation({
//   query: (email) => ({
//     url: SEND_RESET_LINK_URL,
//     method: "POST",
//     body: { email },
//   }),
// }),
// resetPassword: builder.mutation({
//   query: ({ token, password }) => ({
//     url: `${RESET_PASSWORD_URL}/${token}`,
//     method: "POST",
//     body: { password },
//   }),
// }),
// changePassword: builder.mutation({
//   query: (data) => ({
//     url: CHANGE_PASSWORD_URL,
//     method: "POST",
//     body: data,
//   }),
// }),
//     generateMFASecret: builder.query({
//       query: () => ({
//         url: GENERATE_MFA_SECRET_URL,
//         method: "GET",
//       }),
//     }),
//     verifyMFAToken: builder.mutation({
//       query: (data) => ({
//         url: VERIFY_MFA_TOKEN_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//     verifyMFATokenForLogin: builder.mutation({
//       query: (data) => ({
//         url: VERIFY_MFA_TOKEN_LOGIN_URL,
//         method: "POST",
//         body: data,
//       }),
//     }),
//   }),
// });

// export const {
//   useSendEmailCodeMutation,
//   useVerifyEmailMutation,
//   useSendPhoneCodeMutation,
//   useVerifyPhoneMutation,
//   useCompleteRegistrationMutation,
//   useCheckIncompleteRegistrationMutation, // Add this
//   useLoginMutation,
//   useLogoutMutation,
//   useVerifyTokenMutation,
//   useSendResetLinkMutation,
//   useResetPasswordMutation,
//   useChangePasswordMutation,
//   useGenerateMFASecretQuery,
//   useVerifyMFATokenMutation,
//   useVerifyMFATokenForLoginMutation,
// } = authSlice;

// **************************************************************

// authSlice.js
import { apiSlice } from "./apiSlice";
import {
  CUSTOMER_GOOGLE_LOGIN_URL,
  CUSTOMER_FACEBOOK_LOGIN_URL,
  CUSTOMER_SIGNUP_URL,
  CUSTOMER_LOGIN_URL,
  CUSTOMER_LOGOUT_URL,
  CUSTOMER_SEND_EMAIL_VERIFICATION_URL,
  CUSTOMER_VERIFY_EMAIL_URL,
  CUSTOMER_VERIFY_TOKEN_URL,
  CUSTOMER_CHANGE_PASSWORD_URL,
  CUSTOMER_SEND_RESET_LINK_URL,
  CUSTOMER_RESET_PASSWORD_URL,
  CUSTOMER_DEACTIVATE_ACCOUNT_URL,
} from "../constants";

export const authSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    googleLogin: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_GOOGLE_LOGIN_URL,
        method: "POST",
        body: data,
      }),
    }),
    facebookLogin: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_FACEBOOK_LOGIN_URL,
        method: "POST",
        body: data,
      }),
    }),
    completeRegistration: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_SIGNUP_URL,
        method: "POST",
        body: data,
      }),
    }),
    login: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_LOGIN_URL,
        method: "POST",
        body: data,
      }),
    }),
    logout: builder.mutation({
      query: () => ({
        url: CUSTOMER_LOGOUT_URL,
        method: "POST",
      }),
    }),
    sendEmailCode: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_SEND_EMAIL_VERIFICATION_URL,
        method: "POST",
        body: data,
      }),
    }),
    verifyEmailCode: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_VERIFY_EMAIL_URL,
        method: "POST",
        body: data,
      }),
    }),
    verifyToken: builder.mutation({
      query: () => ({
        url: CUSTOMER_VERIFY_TOKEN_URL,
        method: "POST",
        credentials: "include",
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_CHANGE_PASSWORD_URL,
        method: "POST",
        body: data, // { oldPassword, newPassword }
      }),
    }),

    sendResetLink: builder.mutation({
      query: (data) => ({
        url: CUSTOMER_SEND_RESET_LINK_URL,
        method: "POST",
        body: data, // { email }
      }),
    }),

    // resetPassword: builder.mutation({
    //   query: (data) => ({
    //     url: CUSTOMER_RESET_PASSWORD_URL,
    //     method: "POST",
    //     body: data, // { token, newPassword }
    //   }),
    // }),
    resetPassword: builder.mutation({
      query: ({ token, password }) => ({
        url: `${CUSTOMER_RESET_PASSWORD_URL}/${token}`,
        method: "POST",
        body: { password },
      }),
    }),
    deactivateAccount: builder.mutation({
      query: () => ({
        url: CUSTOMER_DEACTIVATE_ACCOUNT_URL,
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGoogleLoginMutation,
  useFacebookLoginMutation,
  useCompleteRegistrationMutation,
  useLoginMutation,
  useLogoutMutation,
  useSendEmailCodeMutation,
  useVerifyEmailCodeMutation,

  useVerifyEmailMutation,
  useSendPhoneCodeMutation,
  useVerifyPhoneMutation,
  useCheckIncompleteRegistrationMutation,
  useCheckStoreNameAvailabilityMutation,
  useVerifyTokenMutation,

  useChangePasswordMutation,
  useSendResetLinkMutation,
  useResetPasswordMutation,
  useDeactivateAccountMutation,
} = authSlice;
